"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    drawerClassNames: function() {
        return drawerClassNames;
    },
    useDrawerStyles_unstable: function() {
        return useDrawerStyles_unstable;
    }
});
const _react = require("@griffel/react");
const drawerClassNames = {
    root: 'fui-Drawer'
};
const useDrawerStyles_unstable = (state)=>{
    'use no memo';
    state.root.className = (0, _react.mergeClasses)(drawerClassNames.root, state.root.className);
    return state;
}; //# sourceMappingURL=useDrawerStyles.styles.js.map
